import Vue from 'vue';
import Router from 'vue-router';
import { getEffectiveTimezone } from '@/utils/timezone';
// 解决导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        if (err && err.name === 'NavigationDuplicated') {
            return err;
        }
        return Promise.reject(err);
    });
};
Vue.use(Router);
/**
 * 始终使用 Home 组件（已整合新旧报警系统）
 * @returns Home 组件
 */
function getHomeComponent() {
    return ROUTE_COMPONENTS.Home;
}
/**
 * 返回统一后的实时监控组件。
 */
function getRealTimeMonitorComponent() {
    return ROUTE_COMPONENTS.RealTimeMonitor;
}
function isSsoPasswordFeaturesEnabled() {
    const runtimeConfigManager = window.ConfigManager;
    if (runtimeConfigManager &&
        typeof runtimeConfigManager.isSsoPasswordFeaturesEnabled === 'function') {
        return runtimeConfigManager.isSsoPasswordFeaturesEnabled() === true;
    }
    const configFeatures = runtimeConfigManager?.getConfig?.()?.features || {};
    let storedFeatures = {};
    try {
        storedFeatures = JSON.parse(localStorage.getItem('features') || '{}');
    }
    catch (error) {
        storedFeatures = {};
    }
    const featureValue = Object.prototype.hasOwnProperty.call(configFeatures, 'enableSsoPasswordFeatures')
        ? configFeatures.enableSsoPasswordFeatures
        : storedFeatures.enableSsoPasswordFeatures;
    return featureValue === true || featureValue === 'true';
}
const ROUTE_COMPONENTS = {
    // 主要页面
    Home: () => import('@/pages/Home.vue'),
    DashBoard: () => import('@/pages/DashBoard.vue'),
    RealTimeMonitor: () => import('@/pages/RealTimeMonitor.vue'),
    TrackPlayback: () => import('@/pages/TrackPlayback.vue'),
    MultiScreenTracks: () => import('@/pages/MultiScreenTracks/index.vue'),
    GeoFence: () => import('@/pages/GeoFence.vue'),
    GeoFenceBind: () => import('@/pages/GeoFenceBind.vue'),
    VideoMonitor: () => import('@/pages/VideoMonitor.vue'),
    VideoPlayback: () => import('@/pages/VideoPlayback.vue'),
    StatisticalReport: () => import('@/pages/StatisticalReport.vue'),
    TrafficStatisticsReport: () => import('@/pages/statisticalReport/TrafficStatisticsReport.vue'),
    CustomMDVR: () => import('@/pages/CustomMDVR/CustomMDVR.vue'),
    ActiveSafety: () => import('@/pages/ActiveSafety.vue'),
    LivePlay: () => import('@/pages/LivePlay/LivePlay.vue'),
    // 测试页面
    BigScreen: () => import('@/pages/test/BigScreen.vue'),
    TestTreeView: () => import('@/pages/testTreeView.vue'),
    TestMap: () => import('@/pages/test/testmap.vue'),
    TestView: () => import('@/pages/test/frankTest.vue'),
    WinstonTest: () => import('@/pages/test/winstonTest.vue'),
    MQTTClientTestPage: () => import('@/pages/test/MQTTClientTestPage.vue'),
    TestSDK: () => import('@/pages/test/TestSDK.vue'),
    // 管理中心
    AccountManage: () => import('@/pages/ManagementCenter/AccountManage.vue'),
    OtaManage: () => import('@/pages/ManagementCenter/OTAManage.vue'),
    AiAuthBackupList: () => import('@/pages/AiAuthBackup/BackupList.vue'),
    RuleManagement: () => import('@/pages/ManagementCenter/RuleManagement.vue'),
    RulePage: () => import('@/pages/ManagementCenter/RulePage.vue'),
    LogQuery: () => import('@/pages/ManagementCenter/LogQuery.vue'),
    OnlineUser: () => import('@/pages/ManagementCenter/OnlineUser.vue'),
    FlowAnalysis: () => import('@/pages/ManagementCenter/FlowAnalysis.vue'),
    // 系统中心
    InfoManagement: () => import('@/pages/SystemCenter/InfoManagement.vue'),
    VehicleSetting: () => import('@/pages/SystemCenter/VehicleSetting.vue'),
    DriverManagement: () => import('@/pages/SystemCenter/InfoDriver.vue'),
    POIManagement: () => import('@/pages/SystemCenter/POIManagement.vue'),
    // 运营管理
    ChargeManage: () => import('@/pages/OperationManage/ChargeManage.vue'),
    MaintenanceManage: () => import('@/pages/OperationManage/MaintenancePage.vue'),
    InsuranceManage: () => import('@/pages/OperationManage/InsuranceManage.vue'),
    MaintenanceCostManage: () => import('@/pages/OperationManage/MaintenanceCostManage.vue'),
    MaintenanceCostSummary: () => import('@/pages/OperationManage/MaintenanceCostSummary.vue'),
    CertificateManage: () => import('@/pages/OperationManage/CertificateManage.vue'),
    // 报警处理
    AlarmView: () => import('@/pages/alarmHandle/alarmView.vue'),
    // 独立页面
    LoginPage: () => import('@/pages/LoginPage.vue'),
    LoginPage1: () => import('@/pages/LoginPage1.vue'),
    ResetPasswordPage: () => import('@/pages/ResetPasswordPage.vue'),
    SSOLoginPage: () => import('@/pages/SSOLoginPage.vue'),
    SamlCallbackPage: () => import('@/pages/SamlCallbackPage.vue'),
    IFrameLive: () => import('@/pages/IFrameLive.vue'),
    IFramePlayback: () => import('@/pages/IFramePlayback.vue'),
    IFrameParameter: () => import('@/pages/IFrameParameter.vue'),
};
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/loginPage',
        },
        {
            path: '/admin',
            beforeEnter() {
                window.location.href = '/admin/';
            },
        },
        {
            path: '/bigtest',
            component: ROUTE_COMPONENTS.BigScreen,
            meta: {
                target: '_blank',
            },
            children: [],
        },
        {
            path: '/customMDVR',
            component: ROUTE_COMPONENTS.CustomMDVR,
            meta: {
                target: '_blank',
            },
            props: (route) => {
                const imei = route.query.imei ?? '';
                const startTime = route.query.startTime ?? '';
                const endTime = route.query.endTime ?? '';
                const lang = route.query.lang ?? 'en-us';
                const alarmIds = route.query.alarmIds ?? '';
                // 确保 timezone 是有效的数字，如果解析失败则使用默认值
                const timezoneParam = route.query.timezone;
                let timezone = getEffectiveTimezone();
                if (timezoneParam) {
                    const parsed = Number(timezoneParam);
                    if (!isNaN(parsed)) {
                        timezone = parsed;
                    }
                }
                return {
                    imei,
                    startTime,
                    endTime,
                    lang,
                    alarmIds,
                    timezone,
                };
            },
        },
        {
            path: '/testSDK',
            component: ROUTE_COMPONENTS.TestSDK,
            meta: {
                target: '_blank',
            },
        },
        {
            path: '/',
            component: getHomeComponent(),
            children: [
                {
                    path: '/dashBoard',
                    component: ROUTE_COMPONENTS.DashBoard,
                },
                // {
                //   path: "/aiScreen",
                //   component: ROUTE_COMPONENTS.BigScreen,
                //   children: [
                //     {
                //       path: "/p1",
                //       component: ROUTE_COMPONENTS.DashBoard,
                //     },
                //     {
                //       path: "/p2",
                //       component: ROUTE_COMPONENTS.RealTimeMonitor,
                //     },
                //     {
                //       path: "/p3",
                //       component: ROUTE_COMPONENTS.TrackPlayback,
                //     },
                //     {
                //       path: "/p4",
                //       component: ROUTE_COMPONENTS.GeoFence,
                //     },
                //   ]
                // },
                {
                    path: '/realTimeMonitor',
                    component: getRealTimeMonitorComponent(),
                },
                {
                    path: '/trackPlayback',
                    component: ROUTE_COMPONENTS.TrackPlayback,
                },
                {
                    path: '/multiScreenTracks',
                    component: ROUTE_COMPONENTS.MultiScreenTracks,
                },
                {
                    path: '/geoFence',
                    component: ROUTE_COMPONENTS.GeoFence,
                },
                {
                    path: '/geoFenceBind',
                    component: ROUTE_COMPONENTS.GeoFenceBind,
                },
                {
                    path: '/videoMonitor',
                    component: ROUTE_COMPONENTS.VideoMonitor,
                },
                {
                    path: '/videoPlayback',
                    component: ROUTE_COMPONENTS.VideoPlayback,
                },
                {
                    path: '/statisticalReport',
                    component: ROUTE_COMPONENTS.StatisticalReport,
                },
                {
                    path: '/trafficStatisticsReport',
                    component: ROUTE_COMPONENTS.TrafficStatisticsReport,
                },
                {
                    path: '/activeSafety',
                    component: ROUTE_COMPONENTS.ActiveSafety,
                },
                {
                    path: '/testTreeView',
                    component: ROUTE_COMPONENTS.TestTreeView,
                },
                {
                    path: '/testMap',
                    component: ROUTE_COMPONENTS.TestMap,
                },
                {
                    path: '/accountManage',
                    component: ROUTE_COMPONENTS.AccountManage,
                },
                {
                    path: '/otaManage',
                    component: ROUTE_COMPONENTS.OtaManage,
                },
                {
                    path: '/aiAuthBackup',
                    component: ROUTE_COMPONENTS.AiAuthBackupList,
                },
                {
                    path: '/ruleManagement',
                    component: ROUTE_COMPONENTS.RuleManagement,
                },
                {
                    path: '/rulePage',
                    component: ROUTE_COMPONENTS.RulePage,
                },
                {
                    path: '/logQuery',
                    component: ROUTE_COMPONENTS.LogQuery,
                },
                {
                    path: '/onlineUser',
                    component: ROUTE_COMPONENTS.OnlineUser,
                },
                {
                    path: '/flowAnalysis',
                    component: ROUTE_COMPONENTS.FlowAnalysis,
                },
                {
                    path: '/infoManagement',
                    component: ROUTE_COMPONENTS.InfoManagement,
                },
                {
                    path: '/vehicleSetting',
                    component: ROUTE_COMPONENTS.VehicleSetting,
                },
                {
                    path: '/driverManagement',
                    component: ROUTE_COMPONENTS.DriverManagement,
                },
                {
                    path: '/pOIManagement',
                    component: ROUTE_COMPONENTS.POIManagement,
                },
                {
                    path: '/chargeManage',
                    component: ROUTE_COMPONENTS.ChargeManage,
                },
                {
                    path: '/maintenanceManage',
                    component: ROUTE_COMPONENTS.MaintenanceManage,
                },
                {
                    path: '/insuranceManage',
                    component: ROUTE_COMPONENTS.InsuranceManage,
                },
                {
                    path: '/maintenanceCostManage',
                    component: ROUTE_COMPONENTS.MaintenanceCostManage,
                },
                {
                    path: '/maintenanceCostSummary',
                    component: ROUTE_COMPONENTS.MaintenanceCostSummary,
                },
                {
                    path: '/certificateManage',
                    component: ROUTE_COMPONENTS.CertificateManage,
                },
                {
                    path: '/alarmView',
                    component: ROUTE_COMPONENTS.AlarmView,
                },
                {
                    path: '/testView',
                    component: ROUTE_COMPONENTS.TestView,
                },
                {
                    path: '/winstonTest',
                    component: ROUTE_COMPONENTS.WinstonTest,
                },
                {
                    path: '/MQTTClient',
                    component: ROUTE_COMPONENTS.MQTTClientTestPage,
                },
            ],
        },
        {
            path: '/loginPage',
            component: ROUTE_COMPONENTS.LoginPage,
        },
        {
            path: '/login1',
            name: 'loginPage1',
            component: ROUTE_COMPONENTS.LoginPage1,
            meta: {
                requiresAuth: false,
                title: 'Login',
            },
        },
        {
            path: '/login',
            component: ROUTE_COMPONENTS.LoginPage,
        },
        {
            path: '/reset-password',
            name: 'resetPassword',
            component: ROUTE_COMPONENTS.ResetPasswordPage,
            meta: {
                requiresAuth: false,
                title: 'Reset Password',
            },
        },
        {
            path: '/sso',
            name: 'ssoLogin',
            component: ROUTE_COMPONENTS.SSOLoginPage,
            meta: {
                requiresAuth: false,
                title: 'SSO Login',
            },
        },
        {
            path: '/saml/callback',
            name: 'samlCallback',
            component: ROUTE_COMPONENTS.SamlCallbackPage,
            meta: {
                requiresAuth: false,
                title: 'SAML Login',
            },
        },
        {
            path: '/live',
            component: ROUTE_COMPONENTS.IFrameLive,
            meta: {
                target: '_blank',
            },
            props: (route) => {
                const imei = route.query.imei ?? ''; // imei
                let chnum = Number(route.query.chnum ?? '4'); // 通道数
                // chnum 可选值: 1,4,6,9,16,36,64如果不在这里面就返回 1
                const validChannelNums = [1, 4, 6, 9, 16, 36, 64];
                if (!validChannelNums.includes(chnum)) {
                    // 如果通道数不在可选值中，则从可选值中找到最接近的值
                    chnum = validChannelNums.find((num) => num >= chnum) ?? 1;
                }
                const channels = (route.query.ch ?? '').split(','); // 通道
                const lang = route.query.lang ?? ''; // 语言 默认英文 en-us
                // 流类型 不填和 1 标识子码流， 0 标识主码流
                const streamtype = Number(route.query.streamtype ?? '0');
                // 隐藏工具栏 不填和0 表示不隐藏上方的工具栏，1 表示隐藏上方的工具栏，2表示鼠标悬停显示上方的工具栏
                const hidetoolbar = Number(route.query.hidetoolbar ?? '0');
                return {
                    chnum,
                    imei,
                    channels,
                    lang,
                    streamtype,
                    hidetoolbar,
                };
            },
        },
        {
            path: '/playback',
            component: ROUTE_COMPONENTS.IFramePlayback,
            meta: {
                target: '_blank',
            },
            props: (route) => {
                const imei = route.query.imei ?? ''; // imei
                const lang = route.query.lang ?? ''; // 语言 默认英文 en-us
                return {
                    imei,
                    lang,
                };
            },
        },
        {
            name: 'parameter',
            path: '/parameter',
            component: ROUTE_COMPONENTS.IFrameParameter,
            meta: {
                target: '_blank',
            },
            props: (route) => {
                const sssid = route.query.sssid ?? ''; // sssid
                const language = route.query.language ?? ''; // 语言 默认英文 en-us
                return {
                    sssid,
                    language,
                };
            },
        },
        {
            name: 'liveplay',
            path: '/liveplay/:idAndChannel/event/:cameraPassword',
            component: ROUTE_COMPONENTS.LivePlay,
            meta: {
                target: '_blank', // 新窗口打开
            },
            props: (route) => {
                const idAndChannelValue = route.params.idAndChannel?.split('@') ?? [];
                const cameraID = idAndChannelValue[0] ?? ''; // 首
                const channelEncode = Number(idAndChannelValue[1] ?? '-1'); // 次
                const cameraPassword = route.params.cameraPassword ?? '';
                return {
                    cameraID,
                    channelEncode,
                    cameraPassword,
                };
            },
        },
    ],
});
// 路由守卫 - 处理 SSO 和普通认证
router.beforeEach((to, from, next) => {
    const ssoPasswordFeaturesEnabled = isSsoPasswordFeaturesEnabled();
    if (to.path === '/sso' && !ssoPasswordFeaturesEnabled) {
        next('/loginPage');
        return;
    }
    // 如果 URL 中包含 SSO 参数,重定向到 SSO 登录页面
    if (ssoPasswordFeaturesEnabled &&
        to.path !== '/sso' &&
        to.path !== '/reset-password' &&
        (to.query.sso_token || to.query.ssoToken || to.query.token)) {
        const queryParams = { ...to.query };
        // 如果有目标路径,保存到 redirect 参数中
        if (to.path !== '/') {
            queryParams.redirect = to.path;
        }
        next({
            path: '/sso',
            query: queryParams,
        });
        return;
    }
    // SSO 登录页面不需要认证
    if (to.path === '/sso' || to.path === '/saml/callback') {
        next();
        return;
    }
    // 公开页面列表 - 不需要登录
    const publicPages = [
        '/loginPage',
        '/login',
        '/reset-password',
        '/live',
        '/playback',
        '/liveplay',
        '/parameter',
        '/customMDVR',
        '/testSDK',
        '/admin',
    ];
    const isPublicPage = publicPages.some((page) => to.path.startsWith(page));
    if (isPublicPage) {
        next();
        return;
    }
    // 检查是否已登录
    const token = localStorage.getItem('ms_token');
    if (!token && to.path !== '/loginPage') {
        next('/loginPage');
        return;
    }
    next();
});
export default router;
